'use client';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function Error({ }) {
  return (
    <div className={"page"}>
      <title>404 Not Found</title>
      <Header />
      <main className={"main"}>
        <div className="pageCategory">Error</div>
        <div className="pageTitle">404 Not Found</div>
        <div className="pageBody">
          <p>Sorry, the page you are looking for could not be found.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}